<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  amount: { type: String, default: '' },
  dueOn: { type: String, default: '' },
  issuedOn: { type: String, default: '' },
  sentOn: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits([
  'update:amount',
  'update:dueOn',
  'update:issuedOn',
  'update:sentOn',
]);
const { t } = useI18n();
const inputClass =
  'min-h-10 rounded-lais border border-lais-border px-3 text-sm disabled:bg-lais-bg-soft';
</script>

<template>
  <div class="grid gap-4 sm:grid-cols-2">
    <LaisField :label="t('REAL_ESTATE_FINANCE.BOLETO.AMOUNT')" required>
      <input
        :value="amount"
        :disabled="disabled"
        inputmode="decimal"
        :class="inputClass"
        @input="emit('update:amount', $event.target.value)"
      />
    </LaisField>
    <LaisField :label="t('REAL_ESTATE_FINANCE.BOLETO.SENT_ON')" required>
      <input
        :value="sentOn"
        :disabled="disabled"
        type="date"
        :class="inputClass"
        @input="emit('update:sentOn', $event.target.value)"
      />
    </LaisField>
    <LaisField :label="t('REAL_ESTATE_FINANCE.BOLETO.ISSUED_ON')" required>
      <input
        :value="issuedOn"
        :disabled="disabled"
        type="date"
        :class="inputClass"
        @input="emit('update:issuedOn', $event.target.value)"
      />
    </LaisField>
    <LaisField :label="t('REAL_ESTATE_FINANCE.BOLETO.DUE_ON')" required>
      <input
        :value="dueOn"
        :disabled="disabled"
        type="date"
        :class="inputClass"
        @input="emit('update:dueOn', $event.target.value)"
      />
    </LaisField>
  </div>
</template>
